import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { verticalSigningQueryKeys } from "../queries/verticalSigning/queryKeys"

import { useVerticalSigningMutation } from "./useVerticalSigningMutation"

export function useVerticalSignPoleUpdate(
    poleId,
    queryParameters,
    config = {},
) {
    const url = `vertical_sign_poles/${poleId}/`
    const queryClient = useQueryClient()

    return useVerticalSigningMutation(
        url,
        axiosInstance.patch,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.pole(poleId) })
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.layer() })
                config.onSuccess?.(data)
            },
        },
    )
}


export function useVerticalSignPoleUpdateDocument(
    poleId,
    queryParameters,
    config = {},
) {
    const url = `vertical_sign_poles/${poleId}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    const axiosFn = (url, values) => {
        const formData = new FormData()
        Object.entries(values).forEach(([key, value]) => {
            if (key === "document") {
                Object.entries(values[key]).forEach(([docKey, docValue]) => {
                    if (Array.isArray(docValue)) {
                        formData.append(`${key}.${docKey}`, JSON.stringify(docValue))
                    } else {
                        formData.append(`${key}.${docKey}`, docValue)
                    }
                })
            } else {
                formData.append(key, value)
            }
        })

        const headers = values.document ? { "Content-Type": "multipart/form-data" } : {}

        return axiosInstance.patch(url, formData, {
            headers: headers,
        })
    }

    return useVerticalSigningMutation(
        url,
        axiosFn,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.pole(poleId) })
                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                config.onSuccess?.(data)
            },
        },
    )
}